import React from 'react'

export const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.28775 8.98599L8.71237 1.56137M8.71237 1.56137H1.28775M8.71237 1.56137V8.98599"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
)
